import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import {
  KitByIdType,
  KitPayload,
  KitsType,
  UpdateKitRequest,
  VariationFormType,
  VariationOptionData,
} from './types'
import { ProductAvailability } from '~/features/kits/lib/model/types'

interface recommendedPriceType {
  recommendedPrice: number
}

export class KitsServices {
  static getKits(
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<KitsType[]>> {
    return apiService.get('/kits', config)
  }

  static getKitById(id: string): Promise<{ data: KitByIdType }> {
    return apiService.get(`/kits/${id}/edit`)
  }

  static createKit(data: KitPayload): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>('/kits', data)
  }

  static getProductsByStoreId(
    storeId: string,
  ): Promise<AxiosResponse<ProductAvailability[]>> {
    return apiService.get(`/stores/${storeId}/products`)
  }

  static createVariation(kitId: string, data: VariationFormType) {
    return apiService.post(`/kits/${kitId}/variations`, data)
  }

  static addOptionsInVariation(
    productId: string,
    params: {
      selections: {
        optionId: string
        optionValueId: string
      }[]
    },
  ): Promise<AxiosResponse<VariationOptionData>> {
    return apiService.post(`/products/${productId}/variations/search`, params)
  }

  static updateKit(
    kitId: string,
    data: UpdateKitRequest,
  ): Promise<AxiosResponse<UpdateKitRequest>> {
    return apiService.put(`/kits/${kitId}/edit`, data)
  }

  static getRecommendedPrice(
    kitId: string,
  ): Promise<{ data: recommendedPriceType }> {
    return apiService.get(`/kits/${kitId}/get-price`)
  }

  static toggleArchiveKit(kitId: string): Promise<AxiosResponse> {
    return apiService.put(`/kits/${kitId}/archive`)
  }

  static generateBarcodeKit(kitId: string, params): Promise<AxiosResponse> {
    return apiService.post(`kits/${kitId}/generateBarcode`, params)
  }
}
